const rdtPanelNames = [
    'rdt_bioline_capture_practitioner'
]

export default {

    async reset({ commit }) {
        commit('reset')
    },

    async generateID({ commit }) {
        let id = Math.random().toString().substr(2, 7)
        if (id.charAt(0) === '0') {
            id = id.replace(0, 2)
        }
        commit('set', { id: id })
        return id
    },

    status({ state, rootGetters }) {

        let status
        try {
            let panel
            rdtPanelNames.forEach(rdtPanel => {
                panel = rootGetters['v4/track/current'].panels.find(p => p.name === rdtPanel)
                let response = panel.responses.find(x => x.selected)
                status = response.value
            })
        }
        catch (e) { console.log(e) }

        if (status === 'timedout' || state.status === 'timedout') {
            return 'expired'
        }

        if (state.status === 'timer_mismatch' || status === 'invalid') {
            return 'invalid'
        }

        if (status === 'positive_pf') {
            return 'positive'
        }

        if (status === 'negative') {
            return 'negative'
        }

        return 'not_started'

    },

    async startTimer({ commit }, payload) {
        let timer_start = payload ? Date.parse(payload) : Date.now()
        commit('set', { timer_start: timer_start, status: 'waiting' })
    },

    async endTimer({ state, commit }, payload) {
        let timer_end = payload ? Date.parse(payload) : Date.now()

        // When test is being skipped
        if (state.status === 'none') return

        if (timer_end - state.timer_start > state.timeout) {
            commit('set', { timer_end: timer_end, status: 'timedout' })
            return
        }
        else if (state.timer_start > timer_end) {
            commit('set', { timer_end: timer_end, status: 'timer_mismatch' })
            return
        }
        else {
            commit('set', { timer_end: timer_end, status: 'captured' })
            return
        }
    },

    async skip({ commit, dispatch }) {
        await dispatch('v4/panel/reset', 'rdt_test_id', { root: true })
        await dispatch('v4/panel/reset', 'rdt_choice', { root: true })
        await dispatch('v4/panel/reset', 'rdt_instructions', { root: true })
        commit('reset')
        commit('set', { skip: true })
    },

    async configure({ commit, rootGetters }, payload = {}) {
        let { model, manufacturer, condition, aquire, timeout, autoStart = false } = payload
        if (rootGetters['v4/mode/get']('rdtTestMode')) {
            aquire = 10000
            timeout = 120000
        }
        commit('set', { model, manufacturer, condition, aquire, timeout, autoStart })
        return true
    }
}
